module.exports = __webpack_public_path__ + "static/card-img-7-506491470a6049f489daa7b5fb1cb82c.jpg";